import { useDjRestAuthUserRetrieve } from "@/api/lctApIComponents";
import { PageHeader } from "@/components/PageHeader";
import { useAppSelector } from "@/hooks/reduxHooks";
import { AccountForm } from "@/settings/components/AccountForm";
import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import pkg from "../../../package.json";
export const Route = createFileRoute("/_auth/settings")({
  component: Settings,
});

function Settings() {
  const token = useAppSelector((state) => state.user.authKey);
  const { data, isLoading, refetch } = useDjRestAuthUserRetrieve({ headers: { Authorization: `Token ${token}` } });

  const version = pkg.version;

  const defaultValues = {
    firstName: data?.first_name ?? "",
    lastName: data?.last_name ?? "",
    email: data?.email ?? "",
    phoneNumber: data?.profile?.phone_number ?? "",
    ranchName: data?.profile?.ranch_name ?? "",
    ranchAddress: data?.profile?.ranch_address ?? "",
    ranchType: data?.profile?.ranch_type ?? undefined,
  };

  return (
    <>
      <PageHeader title="Settings" subtitle={`v${version}`} />
      {isLoading ? (
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
      ) : (
        <main className="h-full overflow-y-auto bg-slate-100 p-6">
          <AccountForm defaultValues={defaultValues} refetch={refetch} />
        </main>
      )}
    </>
  );
}
